export const RESERVED_TYPE_COLOR = '#000000'
